import React from 'react';
import styles from "../../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";
import {observer} from "mobx-react";
import {CompetitorPlayersStatsModulePlayerStatsShotMapGoalView} from "./competitor-players-stats-module.player-stats.shot-map.goal-view";

export const CompetitorPlayersStatsModulePlayerStatsShotMapSelector = observer(({controller}) => {
  const {state} = controller;
  const {sportContext, isGoalViewExpanded} = state;
  const {shouldRenderSelector} = sportContext;

  const goalViewProps = {
    controller,
    isGoalViewExpanded
  }

  return (
    shouldRenderSelector ? <div className={classNames(styles.selector)}>
      <CompetitorPlayersStatsModulePlayerStatsShotMapGoalView {...goalViewProps}/>
    </div> : null

  )
});
